module.exports = __webpack_public_path__ + "img/ssb_menu10.bc4d6a71.png";